import { AppState } from '../../bootstrap/redux/state/AppState';

export function selectMaxSiteRoleForServerUserSpace(state: AppState) {
  return state.serverUsersSpace.maxSiteRole;
}

export function selectMaxSiteRoleCountsForServerUserSpace(state: AppState) {
  return state.serverUsersSpace.maxSiteRoleCounts;
}
